import { Component, ElementRef, inject, input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { FaultyVehicleDataService } from '../../../service/FaultyVehicleData.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import {
  VehicleDataConfirmationDialogComponent
} from "../../../helpers/vehicle-data-confirmation-dialog/vehicle-data-confirmation-dialog.component";

@Component({
  selector: 'app-pure-original-faulty-vehicle-data-table',
  templateUrl: './pure-original-faulty-vehicle-data-table.component.html',
  styleUrl: './pure-original-faulty-vehicle-data-table.component.css'
})
export class PureOriginalFaultyVehicleDataTableComponent implements OnInit, OnChanges {

  faultyVehicleDataService = inject(FaultyVehicleDataService);
  faultyValue = input<string>();
  pureOriginalIds = signal<number[]>([]);
  router = inject(Router);
  elRef = inject(ElementRef);
  private dialog = inject(MatDialog);
  isLoading = signal<boolean>(false);
  resetHeaderActionValue = signal<boolean>(false);
  faultyEcuBuild = input<string>();
  constructor() {}

  ngOnInit() {
    this.faultyVehicleDataService.getTableHeaderNamesForFaultyPureOriginals();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["faultyValue"] &&
        changes["faultyValue"].previousValue !== changes["faultyValue"].currentValue) {

      this.isLoading.set(true);
      this.faultyVehicleDataService.faultyPureOriginals.set([]);
      this.faultyVehicleDataService.pureOriginalsIsLoading.set(true);

      const tableElement: HTMLElement = this.elRef.nativeElement.querySelector('.table-container');
      if (tableElement) {
        tableElement.scrollTop = 0;
      }

      this.resetHeaderActionValue.set(true);
      this.pureOriginalIds.set([]);

      setTimeout(() => {
        this.resetHeaderActionValue.set(false);
      }, 0);

      this.getFaultyPureOriginalsByValue(changes["faultyValue"].currentValue);
    }
  }

  getFaultyPureOriginalsByValue(faultyValue: string) {
    this.faultyVehicleDataService.getFaultyPureOriginalsByValue(faultyValue);
    this.isLoading.set(false);
  }

  viewDetails($event: any, element: any) {
    const isChecked = $event.target.checked;
    if (isChecked) {
      this.pureOriginalIds.update((prevIds) => [...prevIds, +element.id]);
    } else {
      this.pureOriginalIds.update((prevIds) =>
          prevIds.filter((id) => id !== +element.id)
      );
    }
  }

  changeSortDirection($event: any) {
    this.faultyVehicleDataService.changeSortDirection($event.valueOf());
  }


  submitPureOriginalIds() {
    const button = document.querySelector<HTMLButtonElement>('.submit-button');
    button?.blur();

    const appRoot = document.querySelector('app-root');
    appRoot?.setAttribute('inert', 'true');

    const selectedIds = this.pureOriginalIds();
    const faultyValue = this.faultyValue();

    const dialogRef = this.dialog.open(VehicleDataConfirmationDialogComponent, {
      width: "350px",
      disableClose: true,
      data: {
        field: this.faultyVehicleDataService.selectedField(),
        faultyValue: faultyValue,
        pureOriginalIds: selectedIds
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      appRoot?.removeAttribute('inert');

      if (result?.success) {
        this.faultyVehicleDataService.getFaultyPureOriginalsByValue(faultyValue);
        this.pureOriginalIds.set([]);
      }
    });
  }




  openPureOriginalDetails(pureOriginalId: number) {
    return this.router.navigate(['/app/pure-originals/pure-original-details'], {
      queryParams: {pureOriginalId: pureOriginalId},
    });
  }

  isElementSelected(pureOriginalId: number) {
    return this.pureOriginalIds().includes(pureOriginalId);
  }

  getSelectedIdOutputs($event: any) {
    if ($event.valueOf().length > 0) {
      this.pureOriginalIds.set($event.valueOf());
    } else {
      this.pureOriginalIds.set([]);
    }
  }
}
